import { useCallback, useRef } from 'react';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrellisIconDropdownItem = ({
  executeAction,
  toolbarAction
}) => {
  const {
    callback,
    menuLabel,
    menuTooltip,
    disabled,
    id,
    icon: Icon,
    placement = 'right',
    autoPlacement = true
  } = toolbarAction;
  const onClick = () => executeAction({
    id,
    callback
  });
  const button = /*#__PURE__*/_jsx(Button, {
    "data-test-id": `toolbar-action-${id}`,
    onClick: onClick,
    disabled: !!disabled,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "start",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(Icon, {}), /*#__PURE__*/_jsx(Text, {
        marginInlineStart: "200",
        children: menuLabel
      })]
    })
  }, id);
  if (menuTooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: menuTooltip,
      placement: placement,
      autoPlacement: autoPlacement,
      children: button
    }, id);
  }
  return button;
};
const ToolbarActionsPopover = props => {
  const {
    open,
    placement,
    onOpenChange,
    executeAction,
    Button: CustomButton,
    arrowSize
  } = props;
  const buttonRef = useRef(null);
  const handleOpenChange = useCallback(evt => {
    if (evt.target.value === true) {
      var _buttonRef$current;
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
    onOpenChange(evt);
  }, [onOpenChange]);
  return /*#__PURE__*/_jsx(Dropdown, {
    open: open,
    placement: placement,
    onOpenChange: handleOpenChange,
    closeOnOutsideClick: true,
    buttonRef: buttonRef,
    buttonUse: "link-on-dark",
    Button: CustomButton,
    arrowSize: arrowSize,
    children: /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: props.actions.map(toolbarAction => /*#__PURE__*/_jsx(TrellisIconDropdownItem, {
        executeAction: executeAction,
        toolbarAction: toolbarAction
      }, toolbarAction.id))
    })
  });
};
export const TrellisToolbarActionsPopover = ToolbarActionsPopover;
export default TrellisToolbarActionsPopover;